import Vue from "vue";
import { Authv2 as Auth } from "@/plugins/stargate-auth";

//We need a promise to make sure we load the config file for the
export default function() {
  const loginUrl = `${location.origin}${location.pathname}`;
  const config = window.$config;

  Vue.use(
    Auth({
      apiURL: config.apiHost,
      baseSite: loginUrl,
      loginURL: config.ssoURL,
      icons: config.ssoNavIcons,
      inactivityTimer: config.ssoInactivityTimer
    })
  );
}
